'use client';

import { BoldRules, ItalicRules, MarkComboRules } from '@platejs/basic-nodes';
import { BoldPlugin, CodePlugin, ItalicPlugin } from '@platejs/basic-nodes/react';

import { CodeLeaf } from '@/components/ui/code-node';

/** Field-tier marks: **bold**, *italic*, `code` (Markdown Guide basic). */
export const FieldMarksKit = [
  BoldPlugin.configure({
    inputRules: [
      BoldRules.markdown({ variant: '*' }),
      MarkComboRules.markdown({ variant: 'boldItalic' }),
    ],
  }),
  ItalicPlugin.configure({
    inputRules: [ItalicRules.markdown({ variant: '*' })],
  }),
  CodePlugin.configure({
    node: { component: CodeLeaf },
  }),
];
